import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IGRNUpdatePutBody, IGRNUpdateResponse } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosResponse, AxiosError } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

type InventoryTaxCreateAPIResponse = { status: true; data: { po_id?: string } } | { status: false; message: string };
AxiosCurlirize(axios, () => {});

export const useGrnUpdateAPI = () => {
  const [updatedPoId, setUpdatedPoId] = useState<string>("");
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (poData: IGRNUpdatePutBody, poId: string, isTo: boolean = false) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!poData) {
          return { status: false, message: "Missing GRN update payload" } as const;
        }
        const url = `${INVENTORY_MODULE?.GRN_UPDATE_API?.baseURL}${poId}/${isTo ? "?request_for=transfer_order" : ""}`;
        const response: InventoryTaxCreateAPIResponse = await axios
          .put(url, poData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IGRNUpdateResponse>): InventoryTaxCreateAPIResponse => {
            console.log("RAW RESPONSE DATA:", res.data);

            if (res.data?.status === true) {
              const po_id = res.data.data?.po_id ?? "";

              setUpdatedPoId(po_id);
              return { status: true, data: { po_id } };
            } else {
              setUpdatedPoId("");
              const message = (res.data as any)?.message || "Error while updating GRN.";
              toast.error(message);
              return { status: false, message };
            }
          })
          .catch((e: AxiosError): InventoryTaxCreateAPIResponse => {
            sendCurl(e.config?.["curlCommand"]);
            captureError(e);
            return { status: false, message: "" } as const;
          });
        return response;
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
        return { status: false, message: "Server Error: " + e.message } as const;
      }
    },
    [configuration, captureError, sendCurl],
  );
  return { updatedPoId, execute };
};
